// extracted by mini-css-extract-plugin
export var disabled = "CheckboxField-module--disabled--qMGuF";
export var errorMessage = "CheckboxField-module--errorMessage--ihHwx";
export var formCheck = "CheckboxField-module--form-check--wWHj1";
export var formCheckInput = "CheckboxField-module--form-check-input--7l4dK";
export var label = "CheckboxField-module--label--LgbYW";